import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';

import * as actions from '../actions';
import * as actionCreators from '../action-creators';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { Actions } from '../../actions';
import * as artists from '@webapp/sdk/artists';
import AppState from '../../state';
import { NewInstance } from '@common/types/data/new-instance';
import SimpleArtist from '@common/types/artist/simple-artist';

export const onboardArtistEpic = (
  action$: Observable<Actions>,
  $state: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, actionCreators.CreateArtist>(actions.CREATE_ARTIST),
    withLatestFrom($state),
    mergeMap(async ([action, state]) => {
      const data: NewInstance<SimpleArtist> = {
        ...action.artistData,
        country: state.user.profile?.country,
        email: action.artistData.email
          ? action.artistData.email
          : state.user.profile?.email,
        telephone: action.artistData.telephone
          ? action.artistData.telephone
          : state.user.profile?.telephone,
      };

      try {
        const artist = await artists.create(
          data,
          state.onboarding.onboarding.id
        );

        return new actionCreators.CreateArtistSuccess(artist);
      } catch (err) {
        return new actionCreators.CreateArtistError(err.message);
      }
    })
  );
